import { html, LitElement } from 'lit';
import styles from './toujou-spinner.css';

class ToujouSpinner extends LitElement {
  static get is() {
    return 'toujou-spinner';
  }

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <svg class="toujou-spinner__svg" viewBox="25 25 50 50">
        <circle class="toujou-spinner__circle" cx="50" cy="50" r="20" stroke-miterlimit="10"/>
      </svg>
    `;
  }
}

customElements.define(ToujouSpinner.is, ToujouSpinner);
